import SiteHeader from '@/pages/home/components/SiteHeader';
import UpdateBar from '@/pages/home/components/UpdateBar';
import HeroSection from '@/pages/home/components/HeroSection';
import CollectionsSection from '@/pages/home/components/CollectionsSection';
import PeopleSection from '@/pages/home/components/PeopleSection';
import RelationsSection from '@/pages/home/components/RelationsSection';
import DossiersSection from '@/pages/home/components/DossiersSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <UpdateBar />
      <main className="w-full">
        <HeroSection />
        <CollectionsSection />
        <PeopleSection />
        <RelationsSection />
        <DossiersSection />
        <TimelineSection />
        <RankingSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}